import React, { useState, useRef, useEffect } from "react";

import { Static, Sticky } from "./components";

const Desktop = ({ page }) => {
  const staticRef = useRef(null);

  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const headerStatic = staticRef.current;

      if (headerStatic)
        setIsScrolled(window.scrollY > headerStatic.clientHeight);
    };

    handleScroll();

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <Static ref={staticRef} page={page} />
      <Sticky isScrolled={isScrolled} />
    </>
  );
};

export default Desktop;
